import fp from '@fingerprintjs/fingerprintjs';
import axios from 'axios';
import { noop } from 'lodash-es';
import { parse } from 'query-string';

const cacheKey = '@fett/deviceId';
export const getDeviceId = async (timeout = 5000) => {
  const search = parse(window.location.href);
  const qs = search?.['di'] as string;
  const channel = search?.['channel'] as string;
  const cache = localStorage.getItem(cacheKey);

  const response = await axios
    .get('https://prq-api.leyanbot.com/oversea_locust_proxy/get_ip_info', { timeout })
    .catch(() =>
      axios.get('https://edge-sgo-api.jolect.com/oversea_locust_proxy/get_ip_info', { timeout }),
    )
    .catch(noop);
  const data = response?.data;
  const ip = data?.ipAddress;
  const countryCode = data?.countryCode || data?.country_code || data?.country;

  let deviceInfo;

  if (qs) {
    if (qs !== cache) {
      localStorage.setItem(cacheKey, qs);
    }
    deviceInfo = {
      ip,
      countryCode,
      deviceId: qs,
      channel,
    };
  } else if (cache) {
    deviceInfo = {
      ip,
      countryCode,
      deviceId: cache,
      channel,
    };
  } else {
    const fpInstance = await fp.load();
    const { components } = await fpInstance.get();
    const result = {
      ...components,
      ip: {
        value: ip,
        duration: 0,
      },
      countryCode: {
        value: countryCode,
        duration: 0,
      },
    };
    const deviceId = fp.hashComponents(result);
    localStorage.setItem(cacheKey, deviceId);
    deviceInfo = {
      ip,
      countryCode,
      deviceId,
      channel,
    };
  }
  (window as any).deviceInfo = deviceInfo;
  return deviceInfo;
};
